/**
 * vue-api-query
 *
 * Quickly to build requests for REST API.
 * Move your logic and backend requests to dedicated classes.
 * Keep your code clean and elegant.
 *
 * @see  https://github.com/robsontenorio/vue-api-query
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

import axios from 'axios'
import { Model } from 'vue-api-query'

// inject global axios instance as http client to Model
Model.$http = axios



// WEBPACK FOOTER //
// ./resources/js/services/vue-api-query.js